export interface EmploymentDetailsProps {
  application: string;
  created_at: string;
  employee_id: string;
  employment_details: {
    start_date: string;
    end_date: string;
    salary: number;
    benefits: string;
    position: string;
  };
  facility: string;
  facility_info: { name: string };
  job: string;
  job_info: {
    job_title: string;
    job_type: string;
    department: string;
    employment_type: string;
    work_type: string;
  };
  medic: string;
  medic_info: any;
  note: string;
  status: string;
  updated_at: string;
  _id: string;
}

export const employmentDetailsData = {
  application: "",
  created_at: "",
  employment_details: {
    start_date: "",
    end_date: "",
    salary: 0,
    benefits: "",
    position: "",
  },
  facility: "",
  facility_info: { name: "" },
  job: "",
  job_info: {
    job_title: "",
    job_type: "",
    department: "",
    employment_type: "",
    work_type: "",
  },
  medic: "",
  medic_info: {},
  note: "",
  status: "",
  updated_at: "",
  _id: "",
  employee_id: "",
};

export interface StatsContents {
  _id: string;
  count: number;
}

export interface employmentStatsProps {
  totalEmployees: number;
  statusCount: StatsContents[];
  activeEmployeesType: StatsContents[];
  activeEmployeesJobType: StatsContents[];
  activeEmployeesWorkType: StatsContents[];
  activeEmployeesDepartment: StatsContents[];
}

export const dummyDataEmployeeStat = {
  totalEmployees: 0,
  statusCount: [{ _id: "", count: 0 }],
  activeEmployeesType: [{ _id: "", count: 0 }],
  activeEmployeesJobType: [{ _id: "", count: 0 }],
  activeEmployeesWorkType: [{ _id: "", count: 0 }],
  activeEmployeesDepartment: [{ _id: "", count: 0 }],
};

export interface CreateEmployeeAppraisalProps {
  employee_id: string;
  performance_rating: number;
  comment: string;
  goals: string;
  overall_summary: string;
  appraisal_type: string;
}

export interface FeedBackData {
  appraisal_type: string;
  comment: string;
  created_at: string;
  employee: string;
  employee_info: { name: string; medic_type: string };
  facility: string;
  facility_info: { name: string; email: string };
  goals: string;
  medic: string;
  medic_info: { name: string; medic_type: string };
  overall_summary: string;
  performance_rating: string;
  strengths: string[];
  updated_at: string;
  _id: string;
}

export const dummyDataFeedback = {
  appraisal_type: "",
  comment: "",
  created_at: "",
  employee: "",
  employee_info: { name: "", medic_type: "" },
  facility: "",
  facility_info: { name: "", email: "" },
  goals: "",
  medic: "",
  medic_info: { name: "", medic_type: "" },
  overall_summary: "",
  performance_rating: "",
  strengths: [],
  updated_at: "",
  _id: "",
};

// src/types/employment.ts
export interface MobilityRecord {
  _id: string;
  medic: string;
  year: number;
  quarter: number;
  countLeave: number;
  countOvertime: number;
  created_at: string;
  fullTimeMonths: number;
  lastUpdated: string;
  locationChanges: number;
  locumMonths: number;
  mobilityScore: number;
  profileCompletion: number;
  roleChanges: number;
  updated_at: string;
}
